import { useReactiveVar } from '@apollo/client'
import { Divider } from '@material-ui/core'
import React, { useState } from 'react'
import {
  dictionariesVar,
  projectVar,
  selectedVersionsVar,
} from '../../apollo/reactive-vars'
import { mapVersionToCalculatedVersion } from '../../calculators/use-calculator'
import { getEmissionModel } from '../../emission-coefficients/emission-coefficients'
import { isNotNull } from '../../util/array-utility'
import { EnergyCalculationMissing } from '../common/EnergyCalculationMissing'
import { ContainerSelector } from '../costs/ContainerSelector'
import { TotalCarbonFootprintTable } from './carbon-footprint-tables/TotalCarbonFootprintTable'

export function CarbonFootprintResultsPage(): React.ReactElement {
  const project = useReactiveVar(projectVar)
  const selectedVersions = useReactiveVar(selectedVersionsVar)
  const { containerIdsToNames } = useReactiveVar(dictionariesVar)
  const [selectedContainerName, setSelectedContainerName] = useState<
    string | null
  >(null)
  if (!project) {
    return <></>
  }

  const handleChange = (name: string | null) => {
    setSelectedContainerName(name)
  }

  const calculatedVersions = selectedVersions.map((version) =>
    mapVersionToCalculatedVersion(version, version.energyCalculator),
  )
  if (calculatedVersions.some((version) => version === null)) {
    return <EnergyCalculationMissing />
  }
  const versions = calculatedVersions.filter(isNotNull)

  const emissionModel = getEmissionModel(project)

  return (
    <>
      <ContainerSelector handleChange={handleChange} />
      <Divider />
      <TotalCarbonFootprintTable
        versions={versions}
        emissionModel={emissionModel}
        selectedBuildingName={selectedContainerName}
        containerIdsToNames={containerIdsToNames}
      />
    </>
  )
}
